import React, { useState, useEffect } from "react";
import Voicemail from "./Voicemail";
import "./comm-records-styling.css";
import {
  BsFillArrowUpCircleFill,
  BsFillArrowDownCircleFill,
} from "react-icons/bs";
import { fetchOfficeUsers } from "../../functions/office/officeUserFuncs";

const VoicemailsContainer = ({ voicemails, users, reload }) => {
  const [message, setMessage] = useState("");
  const [voicemailsArray, setVoicemailsArray] = useState(voicemails);

  const [ascending, setAscending] = useState(false);

  useEffect(() => {
    // setVoicemailsArray(voicemails);
    // console.log("Voicemail container", voicemailsArray);
    const sortedRecordings = [...voicemails].sort((a, b) => {
      if (ascending) {
        return a.recordingStart.localeCompare(b.recordingStart);
      } else {
        return b.recordingStart.localeCompare(a.recordingStart);
      }
    });

    setVoicemailsArray(sortedRecordings);
  }, [ascending, voicemails]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setMessage("No voicemails to display.");
  //   }, 10000);
  // }, []);

  return (
    <div className="comm-records-container">
      {voicemails.length > 0 ? (
        <>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th
                    className="table-heading"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      border: "1px",
                    }}
                  >
                    <p>Date</p>
                    <div className="table-heading-icon-wrapper">
                      {ascending === true ? (
                        <BsFillArrowUpCircleFill
                          size={18}
                          color="#022536"
                          onClick={() => setAscending(false)}
                          title="Oldest to Newest"
                        />
                      ) : (
                        <BsFillArrowDownCircleFill
                          size={18}
                          color="#022536"
                          onClick={() => setAscending(true)}
                          title="Newest to Oldest"
                        />
                      )}
                    </div>{" "}
                  </th>
                  <th className="table-heading">Time</th>
                  <th className="table-heading">From</th>
                  <th className="table-heading">To</th>
                  <th className="table-heading">Duration</th>
                  <th className="table-heading">Play / Download</th>
                  <th className="table-heading">Archive</th>
                </tr>
              </thead>
              <tbody>
                {voicemailsArray.map((voicemail) => (
                  <Voicemail
                    key={voicemail._id}
                    reload={reload}
                    voicemail={voicemail}
                    users={users}
                  />
                ))}
              </tbody>
            </table>
          </div>
          <p>*Time: 24hr timestamp shown in local timezone.</p>{" "}
        </>
      ) : (
        <p>No voicemails to display.</p>
      )}
    </div>
  );
};

export default VoicemailsContainer;
